import TtyIcon from '@mui/icons-material/Tty'
import { Badge, IconButton } from '@mui/material'
import { useCallerIdHubContext } from 'hooks/usePOSHubContext/usePOSHubContext'
import { isEmpty } from 'lodash-es'
import { useCallback, useState } from 'react'
import MultipleActiveCallingDialog from './MultipleActiveCallingDialog/MultipleActiveCallingDialog'

interface CallerIdButtonProps {
    onSubmit: (phoneNumber: string) => void
}

function CallerIdButton(props: CallerIdButtonProps) {
    const { onSubmit } = props
    const { activePhoneCallerInfos } = useCallerIdHubContext()

    const [
        openMultipleActiveCallingDialog,
        setOpenMultipleActiveCallingDialog,
    ] = useState<boolean>(false)

    const handleOnClick = useCallback(() => {
        if (openMultipleActiveCallingDialog || isEmpty(activePhoneCallerInfos))
            return

        setOpenMultipleActiveCallingDialog(true)
    }, [activePhoneCallerInfos, openMultipleActiveCallingDialog])

    const onSelectPhoneInfo = useCallback(
        (phoneNumber: string) => {
            onSubmit(phoneNumber)
            setOpenMultipleActiveCallingDialog(false)
        },
        [onSubmit],
    )

    return (
        <IconButton
            color="primary"
            disabled={isEmpty(activePhoneCallerInfos)}
            onClick={handleOnClick}
        >
            <Badge badgeContent={activePhoneCallerInfos.length} color="error">
                <TtyIcon />
            </Badge>
            <MultipleActiveCallingDialog
                open={openMultipleActiveCallingDialog}
                onSelect={onSelectPhoneInfo}
                onClose={() => setOpenMultipleActiveCallingDialog(false)}
            />
        </IconButton>
    )
}

export default CallerIdButton
